<script setup lang="ts">
const progress = [
  {
    class: 'w-[65%] mb-6'
  },
  {
    class: 'w-[15%] mb-2'
  },
  {
    class: 'w-[25%] mb-2'
  },
  {
    class: 'w-[20%] mb-6'
  },
  {
    class: 'w-[50%] mb-2'
  },
  {
    class: 'w-[40%] mb-2'
  }
]
</script>

<template>
  <div class="relative w-full animate-pulse rounded-lg border-[1px] p-4">
    <div :class="item.class" class="h-4" v-for="(item, index) in progress" :key="index">
      <div class="h-full w-full overflow-hidden rounded-sm bg-gray-200">
        <div class="progress-bar-value h-full w-full bg-white opacity-30"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.progress-bar-value {
  animation: indeterminateAnimation 1s infinite linear;
  transform-origin: 0% 50%;
}

@keyframes indeterminateAnimation {
  0% {
    transform: translateX(0) scaleX(0);
  }
  40% {
    transform: translateX(0) scaleX(0.4);
  }
  100% {
    transform: translateX(100%) scaleX(0.5);
  }
}
</style>
